// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-table-indicadores[data-v-7fe0878f] .q-table__card{-webkit-box-shadow:none;box-shadow:none}.container-table-indicadores[data-v-7fe0878f] .q-card__section--vert{padding:0!important}.container-table-indicadores[data-v-7fe0878f] .titleCardEdicion{margin:10px 282px 0 15px;font-family:DINPro;font-weight:500;font-size:20px;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:.29px;color:#000}", ""]);
// Exports
module.exports = exports;
